import { message } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { checkMini, crossMini, lockMini, processing } from '../../../../assets';
import Button from '../../../../components/Common/Button/Button';
import Modal from '../../../../components/Modal/Modal';

import { copyToClipboard } from '../../../../utils/helper';
import { ITransactionItem } from '../../types';
import { Wallet_Asset_Transaction_Kind_Id } from '../../../../generated/mlmbox/types/wallet';
import { Bonus_Kind_Id } from '../../../../generated/mlmbox/types/bonus';
import { Status_Transaction } from '../../../../generated/mlmbox/types/status';

export function TransactionItem(props: ITransactionItem) {
    const [time] = useState(new Date(props.createdAt * 1000));
    const [transactionDetailsVisible, setTransactionDetailsVisible] = useState(false);
    const { t } = useTranslation();
    // console.log(props);
    const getHeaderTitle = () => {
        const { metadata, kindId } = props;
        const uniqueField = metadata?.uniqueField;

        if (!uniqueField) {
            return '';
        }

        let result = uniqueField.oneofKind === 'bonus' ? '' : getKindTitle(kindId);

        switch (kindId) {
            case 2:
                if (uniqueField.oneofKind === 'bonus') {
                    const sourceKind = uniqueField.bonus.source.oneofKind;
                    const bonusId = uniqueField.bonus.bonusId;

                    // if (sourceKind === 'matrix') {
                    //     return (result = `P${uniqueField.bonus.source.matrix.source?.treeId || '?'}`);
                    // }

                    if (
                        Bonus_Kind_Id.BONUS_GAME_TOKEN_WEB3_PURCHASE_PARTNERS === bonusId ||
                        Bonus_Kind_Id.BONUS_GAME_TOKEN_WEB3_PURCHASE_PERSONAL === bonusId ||
                        Bonus_Kind_Id.BONUS_GAME_TOKEN_EXCHANGE_PARTNERS === bonusId ||
                        Bonus_Kind_Id.BONUS_GAME_TOKEN_EXCHANGE_PERSONAL === bonusId
                    )
                        return (result = t('r'));

                    if (
                        Bonus_Kind_Id.BONUS_GAME_TOKEN_PROMOTION_TOP_MATRIX === bonusId &&
                        uniqueField.bonus.source.oneofKind === 'gameTokenPromotionTopMatrix'
                    ) {
                        return (result = `${t('n')} P${uniqueField.bonus.source.gameTokenPromotionTopMatrix.treeId}`);
                    }

                    if (Bonus_Kind_Id.BONUS_GAME_TOKEN_PROMOTION_BINARY === bonusId) {
                        return (result = `${t('n')} B800`);
                    }

                    if (
                        Bonus_Kind_Id.BONUS_GAME_TOKEN_PROMOTION_CASHBACK === bonusId &&
                        uniqueField.bonus.source.oneofKind === 'gameTokenPromotionCashback'
                    ) {
                        return (result = `${t('k')} P${uniqueField.bonus.source.gameTokenPromotionCashback.treeId}`);
                    }

                    if (bonusId === Bonus_Kind_Id.BONUS_MATRIX && sourceKind === 'matrix') {
                        return (result = result + ' ' + `${t('bonus')} P${uniqueField.bonus.source.matrix.target?.treeId || '?'}`);
                    }

                    if (bonusId === Bonus_Kind_Id.BONUS_BINARY && sourceKind === 'binary') {
                        return (result = result + ' ' + `${t('bonus')} B${uniqueField.bonus.source.binary.treeId === 16 ? '25' : '800'}`);
                    }

                    if (bonusId === Bonus_Kind_Id.BONUS_BINARY_MATCHING && sourceKind === 'binaryMatching') {
                        return (result =
                            result + ' ' + `${t('matching_bonus')} B${uniqueField.bonus.source.binaryMatching.treeId === 16 ? '25' : '800'}`);
                    }

                    if (bonusId === Bonus_Kind_Id.BONUS_CARD_BONUS_HUNTER && sourceKind === 'cardBonusHunter') {
                        return (result = result + ' ' + `Hunter ${t('bonus')}`);
                    }

                    if (bonusId === Bonus_Kind_Id.GIFT) {
                        return (result = result + ' ' + `${t('bonus_p')}`);
                    }
                }
                break;

            case 3:
                if (uniqueField.oneofKind === 'keeperBookingTreeId') {
                    const treeId = uniqueField.keeperBookingTreeId;
                    if (treeId === 16) return (result = result + ' ' + 'B25');
                    if (treeId === 17) return (result = result + ' ' + 'B800');
                    return (result = result + ' ' + `P${treeId}`);
                }
                if (uniqueField.oneofKind === 'positionCreated') {
                    const treeId = uniqueField.positionCreated.treeId;
                    if (treeId === 16) return (result = result + ' ' + 'B25');
                    if (treeId === 17) return (result = result + ' ' + 'B800');
                    return (result = result + ' ' + `P${treeId}`);
                }
                break;

            case 5:
                if (uniqueField.oneofKind === 'withdrawal') {
                    const address = uniqueField.withdrawal?.address;
                    return (result = result + ' ' + (address ? `***${address.slice(-5)}` : ''));
                }
                break;

            case 11:
            case 12:
                const treeId =
                    uniqueField.oneofKind === 'keeperBookingTreeId'
                        ? uniqueField.keeperBookingTreeId
                        : uniqueField.oneofKind === 'keeperReinvest'
                        ? uniqueField.keeperReinvest.treeId
                        : uniqueField.oneofKind === 'keeperInitialTreeId'
                        ? uniqueField.keeperInitialTreeId
                        : undefined;

                if (treeId === 16) return (result = result + ' ' + 'B25');
                if (treeId === 17) return (result = result + ' ' + 'B800');

                if (uniqueField.oneofKind === 'bonus') {
                    const sourceKind = uniqueField.bonus.source.oneofKind;
                    const bonusId = uniqueField.bonus.bonusId;

                    if (
                        Bonus_Kind_Id.BONUS_GAME_TOKEN_WEB3_PURCHASE_PARTNERS === bonusId ||
                        Bonus_Kind_Id.BONUS_GAME_TOKEN_WEB3_PURCHASE_PERSONAL === bonusId ||
                        Bonus_Kind_Id.BONUS_GAME_TOKEN_EXCHANGE_PARTNERS === bonusId ||
                        Bonus_Kind_Id.BONUS_GAME_TOKEN_EXCHANGE_PERSONAL === bonusId
                    )
                        return (result = kindId === Wallet_Asset_Transaction_Kind_Id.HOLD ? t('r_hold') : t('r_unhold'));

                    if (
                        Bonus_Kind_Id.BONUS_GAME_TOKEN_PROMOTION_CASHBACK === bonusId &&
                        uniqueField.bonus.source.oneofKind === 'gameTokenPromotionCashback'
                    ) {
                        return (result =
                            kindId === Wallet_Asset_Transaction_Kind_Id.HOLD
                                ? `${t('k_hold')} `
                                : `${t('k_unhold', { tree: `P${uniqueField.bonus.source.gameTokenPromotionCashback.treeId}` })}`);
                    }
                }

                return (result = result + ' ' + (treeId ? `P${treeId}` : '?'));
        }
        // if (!result) {
        //     console.log(metadata);
        //     console.log(kindId);
        //     console.log(uniqueField);
        // }
        return result;
    };

    function getKindTitle(kindId: Wallet_Asset_Transaction_Kind_Id): string {
        switch (kindId) {
            case Wallet_Asset_Transaction_Kind_Id.BURNED:
                return t('wallet.transactions.kinds.burned');
            case Wallet_Asset_Transaction_Kind_Id.CANCELED:
                return t('wallet.transactions.kinds.canceled');
            case Wallet_Asset_Transaction_Kind_Id.DEPOSIT:
                return t('wallet.transactions.kinds.deposit');
            case Wallet_Asset_Transaction_Kind_Id.EARNED:
                return t('wallet.transactions.kinds.earned');
            case Wallet_Asset_Transaction_Kind_Id.EXCHANGE:
                if (props.assetId === 2) {
                    return Math.sign(Number(props.amount)) === -1
                        ? t('exchangeSpent', { currency: '$MOON' })
                        : t('exchangeBuy', { currency: '$MOON' });
                } else {
                    return Math.sign(Number(props.amount)) === -1
                        ? t('exchangeBuy', { currency: '$MOON' })
                        : t('exchangeSpent', { currency: '$MOON' });
                }
            case Wallet_Asset_Transaction_Kind_Id.DEPOSIT_WALLET_TRANSFER:
                return (
                    t('wallet.transactions.kinds.transfer') +
                    ` ${t('who')}` +
                    (props.metadata?.uniqueField.oneofKind === 'account'
                        ? ` @${props.metadata?.uniqueField.account?.account?.login}`
                        : props.metadata?.uniqueField.oneofKind === 'accountId'
                        ? ` id${props.metadata?.uniqueField.accountId}`
                        : '')
                );
            case Wallet_Asset_Transaction_Kind_Id.HOLD:
                return t('wallet.transactions.kinds.hold');
            case Wallet_Asset_Transaction_Kind_Id.SPENT:
                return t('wallet.transactions.kinds.spent');
            case Wallet_Asset_Transaction_Kind_Id.UNHOLD:
                return t('wallet.transactions.kinds.unhold');
            case Wallet_Asset_Transaction_Kind_Id.UNKNOWN:
                return t('wallet.transactions.kinds.unknown');
            case Wallet_Asset_Transaction_Kind_Id.WITHDRAWAL:
                return t('wallet.transactions.kinds.withdrawal');
            case Wallet_Asset_Transaction_Kind_Id.WITHDRAWAL_FEE:
                return t('wallet.transactions.kinds.withdrawal_fee');
            case Wallet_Asset_Transaction_Kind_Id.WITHDRAWAL_WALLET_TRANSFER:
                return (
                    t('wallet.transactions.kinds.withdrawal_wallet') +
                    (props.metadata?.uniqueField.oneofKind === 'account'
                        ? ` @${props.metadata?.uniqueField.account?.account?.login}`
                        : props.metadata?.uniqueField.oneofKind === 'accountId'
                        ? ` id${props.metadata?.uniqueField.accountId}`
                        : '')
                );
            default:
                return '';
        }
    }
    // console.log(props);
    return (
        <>
            <div
                className="transaction-items__item"
                onClick={() =>
                    props.kindId === Wallet_Asset_Transaction_Kind_Id.WITHDRAWAL &&
                    props.metadata?.uniqueField.oneofKind === 'withdrawal' &&
                    setTransactionDetailsVisible(true)
                }>
                <div className="info">
                    <div className="icon">
                        {(props.kindId === 7 || props.kindId === 5 || props.kindId === 6 || props.kindId === 11 || props.kindId === 4) && (
                            <svg
                                style={{
                                    transform: Math.sign(Number(props.amount)) === -1 ? 'rotate(0)' : 'rotate(180deg)',
                                }}
                                xmlns="http://www.w3.org/2000/svg"
                                width="14"
                                height="18"
                                viewBox="0 0 14 18"
                                fill="none">
                                <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M6.29289 0.292893C6.68342 -0.0976311 7.31658 -0.0976311 7.70711 0.292893L13.7071 6.29289C14.0976 6.68342 14.0976 7.31658 13.7071 7.70711C13.3166 8.09763 12.6834 8.09763 12.2929 7.70711L8 3.41421V17C8 17.5523 7.55228 18 7 18C6.44772 18 6 17.5523 6 17V3.41421L1.70711 7.70711C1.31658 8.09763 0.683417 8.09763 0.292893 7.70711C-0.0976311 7.31658 -0.0976311 6.68342 0.292893 6.29289L6.29289 0.292893Z"
                                    fill="white"
                                />
                            </svg>
                        )}
                        {props.kindId === 12 && (
                            <svg
                                style={{
                                    transform: 'rotate(180deg)',
                                }}
                                xmlns="http://www.w3.org/2000/svg"
                                width="14"
                                height="18"
                                viewBox="0 0 14 18"
                                fill="none">
                                <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M6.29289 0.292893C6.68342 -0.0976311 7.31658 -0.0976311 7.70711 0.292893L13.7071 6.29289C14.0976 6.68342 14.0976 7.31658 13.7071 7.70711C13.3166 8.09763 12.6834 8.09763 12.2929 7.70711L8 3.41421V17C8 17.5523 7.55228 18 7 18C6.44772 18 6 17.5523 6 17V3.41421L1.70711 7.70711C1.31658 8.09763 0.683417 8.09763 0.292893 7.70711C-0.0976311 7.31658 -0.0976311 6.68342 0.292893 6.29289L6.29289 0.292893Z"
                                    fill="white"
                                />
                            </svg>
                        )}
                        {props.kindId === 3 && (
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                id="fill-none">
                                <path
                                    d="M22 10H2M11 14H6M2 8.2L2 15.8C2 16.9201 2 17.4802 2.21799 17.908C2.40973 18.2843 2.71569 18.5903 3.09202 18.782C3.51984 19 4.07989 19 5.2 19L18.8 19C19.9201 19 20.4802 19 20.908 18.782C21.2843 18.5903 21.5903 18.2843 21.782 17.908C22 17.4802 22 16.9201 22 15.8V8.2C22 7.0799 22 6.51984 21.782 6.09202C21.5903 5.7157 21.2843 5.40974 20.908 5.21799C20.4802 5 19.9201 5 18.8 5L5.2 5C4.0799 5 3.51984 5 3.09202 5.21799C2.7157 5.40973 2.40973 5.71569 2.21799 6.09202C2 6.51984 2 7.07989 2 8.2Z"
                                    stroke="white"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                            </svg>
                        )}
                        {(props.kindId === 1 || props.kindId === 10) && (
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none">
                                <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z"
                                    fill="white"
                                />
                            </svg>
                        )}
                        {props.kindId === 8 && (
                            <svg
                                style={{
                                    transform: Math.sign(Number(props.amount)) === -1 ? 'rotate(0)' : 'rotate(180deg)',
                                }}
                                xmlns="http://www.w3.org/2000/svg"
                                width="14"
                                height="18"
                                viewBox="0 0 14 18"
                                fill="none">
                                <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M6.29289 0.292893C6.68342 -0.0976311 7.31658 -0.0976311 7.70711 0.292893L13.7071 6.29289C14.0976 6.68342 14.0976 7.31658 13.7071 7.70711C13.3166 8.09763 12.6834 8.09763 12.2929 7.70711L8 3.41421V17C8 17.5523 7.55228 18 7 18C6.44772 18 6 17.5523 6 17V3.41421L1.70711 7.70711C1.31658 8.09763 0.683417 8.09763 0.292893 7.70711C-0.0976311 7.31658 -0.0976311 6.68342 0.292893 6.29289L6.29289 0.292893Z"
                                    fill="white"
                                />
                            </svg>
                        )}

                        {props.kindId === 2 &&
                            props.metadata?.uniqueField.oneofKind === 'bonus' &&
                            props.metadata.uniqueField.bonus.source.oneofKind !== 'gameTokenWeb3PurchasePersonal' &&
                            props.metadata.uniqueField.bonus.source.oneofKind !== 'gameTokenWeb3PurchasePartners' &&
                            props.metadata.uniqueField.bonus.source.oneofKind !== 'gameTokenExchangePartners' &&
                            props.metadata.uniqueField.bonus.source.oneofKind !== 'gameTokenExchangePersonal' &&
                            props.metadata.uniqueField.bonus.source.oneofKind !== 'gameTokenPromotionBinary' &&
                            props.metadata.uniqueField.bonus.source.oneofKind !== 'gameTokenPromotionTopMatrix' && (
                                <svg
                                    width="21"
                                    height="20"
                                    viewBox="0 0 21 20"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        fill-rule="evenodd"
                                        clip-rule="evenodd"
                                        d="M18.4735 4.58097H18.7591C19.2882 4.58397 19.7949 4.79552 20.1691 5.16971C20.5433 5.5439 20.7548 6.05056 20.7578 6.57974V18.0012C20.7548 18.5304 20.5433 19.0371 20.1691 19.4113C19.7949 19.7855 19.2882 19.997 18.7591 20H2.76896C2.25379 19.9766 1.76733 19.756 1.41019 19.384C1.05305 19.012 0.85255 18.5169 0.850153 18.0012V6.57974C0.838361 6.45056 0.838361 6.32058 0.850153 6.19141C0.85529 6.14968 0.85529 6.10749 0.850153 6.06577C0.871602 5.98044 0.898303 5.89653 0.930103 5.8145L0.998632 5.68886C1.03231 5.61798 1.07045 5.54931 1.11285 5.48327C1.1368 5.44043 1.16768 5.40183 1.20422 5.36906L1.34128 5.19773L1.46691 5.08352L1.62681 4.94646L1.76387 4.7523L1.94662 4.6495H2.10652L2.30068 4.58097H2.48343H2.60906L16.2006 0.0123739C16.2913 -0.00412463 16.3841 -0.00412463 16.4748 0.0123739C17.0039 0.0153722 17.5106 0.226918 17.8848 0.601111C18.259 0.975304 18.4705 1.48196 18.4735 2.01114V4.58097ZM16.7057 1.84399C16.671 1.79506 16.6224 1.75777 16.5661 1.73702L8.0457 4.58097H16.7603V2.01114C16.7594 1.95119 16.7404 1.89291 16.7057 1.84399ZM18.961 18.2031C19.0145 18.1496 19.0446 18.077 19.0446 18.0012V6.57974C19.0446 6.50401 19.0145 6.43138 18.961 6.37783C18.9074 6.32428 18.8348 6.2942 18.7591 6.2942H2.76896C2.69324 6.2942 2.62061 6.32428 2.56706 6.37783C2.51351 6.43138 2.48343 6.50401 2.48343 6.57974V18.0012C2.48343 18.077 2.51351 18.1496 2.56706 18.2031C2.62061 18.2567 2.69324 18.2868 2.76896 18.2868H18.7591C18.8348 18.2868 18.9074 18.2567 18.961 18.2031ZM17.3314 12.2906C17.3314 13.079 16.6922 13.7182 15.9037 13.7182C15.1152 13.7182 14.476 13.079 14.476 12.2906C14.476 11.5021 15.1152 10.8629 15.9037 10.8629C16.6922 10.8629 17.3314 11.5021 17.3314 12.2906Z"
                                        fill="#fff"
                                    />
                                </svg>
                            )}
                        {props.metadata?.uniqueField.oneofKind === 'bonus' &&
                            (props.metadata.uniqueField.bonus.source.oneofKind === 'gameTokenWeb3PurchasePersonal' ||
                                props.metadata.uniqueField.bonus.source.oneofKind === 'gameTokenWeb3PurchasePartners' ||
                                props.metadata.uniqueField.bonus.source.oneofKind === 'gameTokenExchangePartners' ||
                                props.metadata.uniqueField.bonus.source.oneofKind === 'gameTokenExchangePersonal' ||
                                props.metadata.uniqueField.bonus.source.oneofKind === 'gameTokenPromotionBinary' ||
                                props.metadata.uniqueField.bonus.source.oneofKind === 'gameTokenPromotionTopMatrix') && (
                                <svg
                                    style={{
                                        transform: Math.sign(Number(props.amount)) === -1 ? 'rotate(0)' : 'rotate(180deg)',
                                    }}
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="14"
                                    height="18"
                                    viewBox="0 0 14 18"
                                    fill="none">
                                    <path
                                        fill-rule="evenodd"
                                        clip-rule="evenodd"
                                        d="M6.29289 0.292893C6.68342 -0.0976311 7.31658 -0.0976311 7.70711 0.292893L13.7071 6.29289C14.0976 6.68342 14.0976 7.31658 13.7071 7.70711C13.3166 8.09763 12.6834 8.09763 12.2929 7.70711L8 3.41421V17C8 17.5523 7.55228 18 7 18C6.44772 18 6 17.5523 6 17V3.41421L1.70711 7.70711C1.31658 8.09763 0.683417 8.09763 0.292893 7.70711C-0.0976311 7.31658 -0.0976311 6.68342 0.292893 6.29289L6.29289 0.292893Z"
                                        fill="white"
                                    />
                                </svg>
                            )}

                        <div
                            className="icon__mini"
                            style={{
                                background:
                                    props.kindId === 11 ? '#0C8CE9' : props.statusId === 0 ? '#FF7C02' : props.statusId === 2 ? '#E7515A' : '#34AB51',
                            }}>
                            <img
                                src={
                                    props.kindId === 11 || props.kindId === 12
                                        ? lockMini
                                        : props.statusId === 0
                                        ? processing
                                        : props.statusId === 1
                                        ? checkMini
                                        : crossMini
                                }
                                alt=""
                            />
                        </div>
                    </div>
                    <div className="title">
                        {/* <h2>
                            {props?.metadata?.uniqueField.oneofKind !== 'bonus'
                                ? getKindTitle(props.kindId)
                                : props.metadata.uniqueField.bonus.bonusId === Bonus_Kind_Id.BONUS_MATRIX &&
                                  props.metadata.uniqueField.bonus.source.oneofKind === 'matrix'
                                ? `${t('bonus')} P${props.metadata.uniqueField.bonus.source.matrix.target?.treeId}`
                                : props.metadata.uniqueField.bonus.bonusId === Bonus_Kind_Id.BONUS_BINARY &&
                                  props.metadata.uniqueField.bonus.source.oneofKind === 'binary'
                                ? `${t('bonus')} B${props.metadata.uniqueField.bonus.source.binary.treeId === 16 ? '25' : '800'}`
                                : props.metadata.uniqueField.bonus.bonusId === Bonus_Kind_Id.BONUS_BINARY_MATCHING &&
                                  props.metadata.uniqueField.bonus.source.oneofKind === 'binaryMatching'
                                ? ` ${t('matching_bonus')} B${props.metadata.uniqueField.bonus.source.binaryMatching.treeId === 16 ? '25' : '800'}`
                                : t('bonus')}

                            {props.kindId === 2 &&
                                props?.metadata?.uniqueField.oneofKind === 'bonus' &&
                                ' за P' +
                                    (props?.metadata?.uniqueField.bonus.source.oneofKind === 'matrix'
                                        ? props?.metadata?.uniqueField.bonus?.source.matrix.source?.positionId
                                        : '?')}
                            {props.kindId === 3 &&
                            props?.metadata?.uniqueField.oneofKind === 'keeperBookingTreeId' &&
                            props?.metadata?.uniqueField.keeperBookingTreeId > 0
                                ? props?.metadata?.uniqueField.keeperBookingTreeId !== 16 &&
                                  props?.metadata?.uniqueField.keeperBookingTreeId !== 17 &&
                                  props?.metadata?.uniqueField.oneofKind === ''` P${props?.metadata?.keeperBookingTreeId}`
                                : ''}
                            {props.kindId === 3 &&
                                props.metadata?.uniqueField.oneofKind === 'positionCreated' &&
                                props?.metadata?.uniqueField.positionCreated?.treeId !== 16 &&
                                props?.metadata?.uniqueField.positionCreated?.treeId !== 17 &&
                                props?.metadata?.uniqueField.positionCreated?.treeId &&
                                ' P' + props?.metadata?.uniqueField.positionCreated?.treeId}
                            {props.kindId === 3 &&
                                props?.metadata?.uniqueField.oneofKind === 'positionCreated' &&
                                props?.metadata?.uniqueField.positionCreated?.treeId === 16 &&
                                ' B25'}
                            {props.kindId === 3 &&
                                props?.metadata?.uniqueField.oneofKind === 'positionCreated' &&
                                props?.metadata?.uniqueField.positionCreated?.treeId === 17 &&
                                ' B800'}

                            {props.kindId === 3 &&
                                props?.metadata?.uniqueField.oneofKind === 'keeperBookingTreeId' &&
                                props?.metadata?.uniqueField.keeperBookingTreeId === 16 &&
                                ' B25'}
                            {props.kindId === 3 &&
                                props?.metadata?.uniqueField.oneofKind === 'positionCreated' &&
                                props?.metadata?.uniqueField.positionCreated?.positionId === 16 &&
                                ' B25'}

                            {props.kindId === 3 &&
                                props?.metadata?.uniqueField.oneofKind === 'keeperBookingTreeId' &&
                                props?.metadata?.uniqueField.keeperBookingTreeId === 17 &&
                                ' B800'}
                            {props.kindId === 3 &&
                                props?.metadata?.uniqueField.oneofKind === 'positionCreated' &&
                                props?.metadata?.uniqueField.positionCreated?.positionId === 17 &&
                                ' B800'}
                            {props.kindId === 5 &&
                                props.metadata?.uniqueField.oneofKind === 'withdrawal' &&
                                ` ***${props?.metadata?.uniqueField.withdrawal?.address.slice(
                                    props?.metadata?.uniqueField.withdrawal?.address.length - 5,
                                    props?.metadata?.uniqueField.withdrawal?.address.length
                                )}`}
                            {props.kindId === 11 &&
                                props?.metadata?.uniqueField.keeperBookingTreeId !== 16 &&
                                props?.metadata?.positionCreated?.positionId !== 16 &&
                                props?.metadata?.keeperBookingTreeId !== 17 &&
                                props?.metadata?.positionCreated?.positionId !== 17 &&
                                ` P${
                                    props?.metadata?.keeperReinvest?.positionId
                                        ? props?.metadata?.keeperReinvest?.treeId
                                        : props?.metadata?.keeperInitialTreeId
                                        ? props?.metadata?.keeperInitialTreeId
                                        : props?.metadata?.keeperBookingTreeId
                                        ? props?.metadata?.keeperBookingTreeId
                                        : '?'
                                }`}
                            {props.kindId === 12 &&
                                props?.metadata?.keeperBookingTreeId !== 16 &&
                                props?.metadata?.positionCreated?.positionId !== 16 &&
                                props?.metadata?.keeperBookingTreeId !== 17 &&
                                props?.metadata?.positionCreated?.positionId !== 17 &&
                                ` P${
                                    props?.metadata?.keeperReinvest?.positionId
                                        ? props?.metadata?.keeperReinvest?.treeId
                                        : props?.metadata?.keeperInitialTreeId
                                        ? props?.metadata?.keeperInitialTreeId
                                        : props?.metadata?.keeperBookingTreeId
                                        ? props?.metadata?.keeperBookingTreeId
                                        : '?'
                                }`}
                            {props.kindId === 11 &&
                                (props?.metadata?.keeperBookingTreeId === 16 ||
                                    props?.metadata?.keeperReinvest?.treeId === 16 ||
                                    props?.metadata?.keeperInitialTreeId === 16) &&
                                ` B25`}
                            {props.kindId === 11 &&
                                (props?.metadata?.keeperBookingTreeId === 17 ||
                                    props?.metadata?.keeperReinvest?.treeId === 17 ||
                                    props?.metadata?.keeperInitialTreeId === 17) &&
                                ` B800`}
                            {props.kindId === 12 &&
                                (props?.metadata?.keeperBookingTreeId === 16 ||
                                    props?.metadata?.keeperReinvest?.treeId === 16 ||
                                    props?.metadata?.keeperInitialTreeId === 16) &&
                                ` B25`}
                            {props.kindId === 12 &&
                                (props?.metadata?.keeperBookingTreeId === 17 ||
                                    props?.metadata?.keeperReinvest?.treeId === 17 ||
                                    props?.metadata?.keeperInitialTreeId === 17) &&
                                ` B800`}
                        </h2> */}
                        <h2>{getHeaderTitle()}</h2>
                        <p>
                            {(time.getHours() < 10 ? '0' + time.getHours() : time.getHours()) +
                                ':' +
                                (time.getMinutes() < 10 ? '0' + time.getMinutes() : time.getMinutes())}
                        </p>
                    </div>
                </div>

                <div className="amount-box">
                    <div className="amount">
                        <p
                            className="amount-value"
                            style={{
                                color: Math.sign(Number(props.amount)) === -1 ? '#E7515A' : '#34AB51',
                            }}>
                            {' '}
                            {Math.sign(Number(props.amount)) === -1 ? '' : '+'}
                            {Number(
                                props.assetId === 1
                                    ? props.kindId === 5
                                        ? Number(props.amount) + Number(props.fee)
                                        : Number(props.amount)
                                    : props.kindId === 5
                                    ? parseInt(String(Number(props.amount) + Number(props.fee)))
                                    : parseInt(props.amount)
                            ).toLocaleString()}
                            {props.assetId === 1 ? <span>$</span> : <></>}
                        </p>
                    </div>
                    <p>{Number(props.assetId === 1 ? props.balance : parseInt(props.balance)).toLocaleString()}</p>
                </div>
            </div>

            {transactionDetailsVisible && (
                <Modal closeBtn={() => setTransactionDetailsVisible(false)}>
                    <div className="transaction-detail">
                        <div className="title">
                            <h1>{t('transactionDetailTitle')}</h1>
                            <p
                                onClick={() => {
                                    copyToClipboard(`#${props.transactionId}`);
                                    message.success(t('copy'));
                                }}>
                                {t('transactionDetailId')} <span>#{props.transactionId}</span>{' '}
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="14"
                                    height="14"
                                    viewBox="0 0 14 14"
                                    fill="none">
                                    <g opacity="0.8">
                                        <path
                                            d="M12.4063 4.12821L8.43604 0.157949C8.33515 0.0569387 8.19828 0.000125678 8.05552 0H6.28219C5.75856 0 5.25637 0.208012 4.88611 0.578276C4.51584 0.948541 4.30783 1.45073 4.30783 1.97436V2.87179H3.41039C2.88676 2.87179 2.38458 3.07981 2.01431 3.45007C1.64405 3.82034 1.43604 4.32252 1.43604 4.84615V12.0256C1.43604 12.5493 1.64405 13.0515 2.01431 13.4217C2.38458 13.792 2.88676 14 3.41039 14H8.43604C8.95967 14 9.46185 13.792 9.83212 13.4217C10.2024 13.0515 10.4104 12.5493 10.4104 12.0256V11.1282H10.5899C11.1135 11.1282 11.6157 10.9202 11.986 10.5499C12.3562 10.1797 12.5642 9.67748 12.5642 9.15385V4.48718C12.5586 4.35192 12.5022 4.22375 12.4063 4.12821ZM8.61552 1.83795L10.7263 3.94872H8.61552V1.83795ZM9.33347 12.0256C9.33347 12.2637 9.23892 12.4919 9.07062 12.6602C8.90232 12.8285 8.67405 12.9231 8.43604 12.9231H3.41039C3.17238 12.9231 2.94411 12.8285 2.77581 12.6602C2.60751 12.4919 2.51296 12.2637 2.51296 12.0256V4.84615C2.51296 4.60814 2.60751 4.37987 2.77581 4.21157C2.94411 4.04327 3.17238 3.94872 3.41039 3.94872H4.30783V9.15385C4.30783 9.67748 4.51584 10.1797 4.88611 10.5499C5.25637 10.9202 5.75856 11.1282 6.28219 11.1282H9.33347V12.0256ZM10.5899 10.0513H6.28219C6.04417 10.0513 5.81591 9.95673 5.64761 9.78843C5.4793 9.62013 5.38475 9.39186 5.38475 9.15385V1.97436C5.38475 1.73634 5.4793 1.50808 5.64761 1.33978C5.81591 1.17147 6.04417 1.07692 6.28219 1.07692H7.5386V4.48718C7.54046 4.62941 7.59779 4.76529 7.69837 4.86587C7.79895 4.96645 7.93483 5.02378 8.07706 5.02564H11.4873V9.15385C11.4873 9.39186 11.3928 9.62013 11.2245 9.78843C11.0562 9.95673 10.8279 10.0513 10.5899 10.0513Z"
                                            fill="#89B1FF"
                                        />
                                    </g>
                                </svg>
                            </p>
                        </div>

                        <div className="about-detail">
                            <p>{t('option_2')}</p>
                            <div className="about-detail__value">
                                <p>
                                    {Math.abs(Number(props.amount) + Number(props.fee)).toLocaleString()}
                                    <span className="usdt">$</span>
                                </p>
                            </div>
                        </div>

                        <div
                            className="about-detail"
                            onClick={() => {
                                props?.metadata?.uniqueField.oneofKind === 'withdrawal' &&
                                    props?.metadata?.uniqueField.withdrawal?.address &&
                                    copyToClipboard(props?.metadata?.uniqueField.withdrawal?.address);
                                message.success(t('copy'));
                            }}>
                            <p>
                                {t('wallet.withdraw.labeles.to', {
                                    network:
                                        props.metadata?.uniqueField.oneofKind === 'withdrawal' &&
                                        props.metadata?.uniqueField.withdrawal?.processingId === 1
                                            ? 'BEP 20'
                                            : props.metadata?.uniqueField.oneofKind === 'withdrawal' &&
                                              props.metadata?.uniqueField.withdrawal?.processingId === 2
                                            ? 'Ethereum'
                                            : '?',
                                })}
                            </p>
                            <div className="about-detail__value">
                                <p style={{ display: 'block' }}>
                                    {props.metadata?.uniqueField.oneofKind === 'withdrawal' && props.metadata?.uniqueField.withdrawal?.address}
                                </p>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="14"
                                    height="14"
                                    viewBox="0 0 14 14"
                                    fill="none">
                                    <g opacity="0.8">
                                        <path
                                            d="M12.4063 4.12821L8.43604 0.157949C8.33515 0.0569387 8.19828 0.000125678 8.05552 0H6.28219C5.75856 0 5.25637 0.208012 4.88611 0.578276C4.51584 0.948541 4.30783 1.45073 4.30783 1.97436V2.87179H3.41039C2.88676 2.87179 2.38458 3.07981 2.01431 3.45007C1.64405 3.82034 1.43604 4.32252 1.43604 4.84615V12.0256C1.43604 12.5493 1.64405 13.0515 2.01431 13.4217C2.38458 13.792 2.88676 14 3.41039 14H8.43604C8.95967 14 9.46185 13.792 9.83212 13.4217C10.2024 13.0515 10.4104 12.5493 10.4104 12.0256V11.1282H10.5899C11.1135 11.1282 11.6157 10.9202 11.986 10.5499C12.3562 10.1797 12.5642 9.67748 12.5642 9.15385V4.48718C12.5586 4.35192 12.5022 4.22375 12.4063 4.12821ZM8.61552 1.83795L10.7263 3.94872H8.61552V1.83795ZM9.33347 12.0256C9.33347 12.2637 9.23892 12.4919 9.07062 12.6602C8.90232 12.8285 8.67405 12.9231 8.43604 12.9231H3.41039C3.17238 12.9231 2.94411 12.8285 2.77581 12.6602C2.60751 12.4919 2.51296 12.2637 2.51296 12.0256V4.84615C2.51296 4.60814 2.60751 4.37987 2.77581 4.21157C2.94411 4.04327 3.17238 3.94872 3.41039 3.94872H4.30783V9.15385C4.30783 9.67748 4.51584 10.1797 4.88611 10.5499C5.25637 10.9202 5.75856 11.1282 6.28219 11.1282H9.33347V12.0256ZM10.5899 10.0513H6.28219C6.04417 10.0513 5.81591 9.95673 5.64761 9.78843C5.4793 9.62013 5.38475 9.39186 5.38475 9.15385V1.97436C5.38475 1.73634 5.4793 1.50808 5.64761 1.33978C5.81591 1.17147 6.04417 1.07692 6.28219 1.07692H7.5386V4.48718C7.54046 4.62941 7.59779 4.76529 7.69837 4.86587C7.79895 4.96645 7.93483 5.02378 8.07706 5.02564H11.4873V9.15385C11.4873 9.39186 11.3928 9.62013 11.2245 9.78843C11.0562 9.95673 10.8279 10.0513 10.5899 10.0513Z"
                                            fill="#89B1FF"
                                        />
                                    </g>
                                </svg>
                            </div>
                        </div>

                        <div className="metadata">
                            <p>
                                {t('operationFee.title')} {Math.abs(Number(props.fee)).toLocaleString()}
                                <span className="usdt">$</span> ({Math.abs(Number(props.fee) / Number(props.amount)).toLocaleString()}%)
                            </p>
                            <div className="ul">
                                <div className="li">
                                    <div className="marker"></div>
                                    {t('option_1')} {Math.abs(Number(props.amount)).toLocaleString()}
                                    <span className="usdt">$</span>
                                </div>

                                <div className="li">
                                    <div className="marker"></div>
                                    {t('option_3')} {Math.abs(Number(props.balance)).toLocaleString()}
                                    <span className="usdt">$</span>
                                </div>
                            </div>
                        </div>

                        <div className={`btn ${props?.statusId === Status_Transaction.SUCCESS ? 'success' : ''}`}>
                            <Button
                                background="var(--gr-b)"
                                onCick={() => {
                                    props?.statusId === Status_Transaction.SUCCESS &&
                                        props.metadata?.uniqueField.oneofKind === 'withdrawal' &&
                                        window?.Telegram?.WebApp.openLink(`https://bscscan.com/tx/${props.metadata?.uniqueField.withdrawal?.hash}`);
                                }}
                                color="#fff"
                                width="100%"
                                title={
                                    props?.statusId === Status_Transaction.SUCCESS
                                        ? t('linkToTranslation')
                                        : props?.statusId === Status_Transaction.REJECTED
                                        ? t('not_succ')
                                        : t('process')
                                }
                            />
                        </div>
                    </div>
                </Modal>
            )}
        </>
    );
}
